const getApiError = (error, defaultMessage = 'Ocurrió un error inesperado.') => {
    if (error.response) {
        // Validation errors (422)
        if (error.response.status === 422 && error.response.data.errors) {
            const errors = error.response.data.errors;
            const firstField = Object.keys(errors)[0];
            if (firstField && errors[firstField].length > 0) {
                return errors[firstField][0];
            }
            return 'La información enviada no es válida.';
        }

        if (error.response.data && error.response.data.message) {
            return error.response.data.message;
        }

        return defaultMessage;
    }

    return 'Ocurrió un error de conexión. Por favor, inténtalo de nuevo.';
};

export default getApiError;
